import styled from 'styled-components';
import { Link } from 'gatsby';

import CaretRight from '../../images/icons/caret-right.svg';

export const Wrapper = styled.div`
  min-height: 3rem;
  font-size: 0.875rem;
  text-transform: uppercase;
`;

export const LinkWrapper = styled(Link)`
  text-decoration: none;
  color: ${(props) => props.theme.color.neutral.v500};

  &:hover {
    text-decoration: none;
    color: ${(props) => props.theme.color.primary.v600};
  }
`;

export const StyledIconRightCaret = styled(CaretRight)`
  width: 5px;
  height: 9px;
  margin-left: 2px;
`;
